import { FunctionComponent } from 'react'
import Sidebar from './sidebar/sidebar'
import PrivateRoutes from 'private-routes'
import { HospitalAdminProvider } from 'features/adminHospital/hospitalAdminContext'
import layoutCss from './layout.module.scss'

const Layout: FunctionComponent<{ handleLogout: () => void }> = ({
  handleLogout,
}) => (
  <HospitalAdminProvider>
    <Sidebar logout={handleLogout} />
    <main className={layoutCss.main}>
      <PrivateRoutes />
    </main>
  </HospitalAdminProvider>
)

export default Layout
